import PropTypes from "prop-types";
import { Paper, Typography, Stack, Chip, Switch, Button, Divider } from "@mui/material";
import MDButton from "components/MDButton";

const CompetencyCard = ({
  competency,
  level,
  mapping,
  whiteCount,
  blackCount,
  canEdit,
  onToggleBW,
  onManagePoints,
  onDelete,
}) => {
  return (
    <Paper
      variant="outlined"
      sx={{
        p: 2,
        mb: 2,
        borderRadius: 2,
      }}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="h6">{competency?.name || "Unknown Competency"}</Typography>

        <Chip
          label={mapping?.bwActive ? "BW Enabled" : "Traditional"}
          color={mapping?.bwActive ? "success" : "default"}
        />
      </Stack>

      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
        Level: {level?.levelName || "-"} ({level?.value || "-"})
      </Typography>

      <Divider sx={{ my: 2 }} />

      {canEdit && (
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography variant="body2">Black & White Assessment</Typography>

          <Switch
            checked={!!mapping?.bwActive}
            onChange={() => onToggleBW(mapping, !mapping?.bwActive)}
          />
        </Stack>
      )}

      {mapping?.bwActive && (
        <Stack direction="row" spacing={1} mt={2}>
          <Chip color="success" label={`${whiteCount || 0} White Points`} />
          <Chip color="error" label={`${blackCount || 0} Black Points`} />
        </Stack>
      )}

      <Stack direction="row" spacing={1} mt={2}>
        {mapping?.bwActive && (
          <MDButton color="primary" variant="outlined" onClick={() => onManagePoints(mapping)}>
            Manage Points
          </MDButton>
        )}

        {canEdit && (
          <MDButton color="error" variant="outlined" onClick={() => onDelete(mapping)}>
            Remove
          </MDButton>
        )}
      </Stack>
    </Paper>
  );
};

CompetencyCard.propTypes = {
  competency: PropTypes.object,
  level: PropTypes.object,
  mapping: PropTypes.object,
  whiteCount: PropTypes.number,
  blackCount: PropTypes.number,
  canEdit: PropTypes.bool,
  onToggleBW: PropTypes.func,
  onManagePoints: PropTypes.func,
  onDelete: PropTypes.func,
};

export default CompetencyCard;
